export const NEXUS_APPLICATION_ACCESS_TABLE = [
  {
    Application: 'Salesforce',
    Status: '✅ Connected',
    'What Was Done': 'OAuth2 wired, lead + opportunity sync, demo-user RFQ trigger',
    'How It Helps': 'CRM pipeline for procurement leads and workflow automation',
  },
  {
    Application: 'HubSpot',
    Status: '✅ Connected',
    'What Was Done': 'SRM objects synced, supplier pipeline and engagement scoring',
    'How It Helps': 'Supplier relationship management alongside CRM deals',
  },
  {
    Application: 'Procurify',
    Status: '✅ Connected',
    'What Was Done': 'Purchase request API, approval routing, budget codes mapped',
    'How It Helps': 'Procurement management from RFQ through approved spend',
  },
  {
    Application: 'Stripe',
    Status: '✅ Connected',
    'What Was Done': 'Payment intent API verified, webhook listener active',
    'How It Helps': 'Ready for checkout and subscription billing when the site goes live',
  },
  {
    Application: 'Mailchimp',
    Status: '✅ Connected',
    'What Was Done': 'Audience sync + RFQ nurture journey mapped',
    'How It Helps': 'Sends trigger emails when demo users submit quotes',
  },
  {
    Application: 'Google Cloud',
    Status: '✅ Connected',
    'What Was Done': 'Workspace linked — ready for Cloud Run, Cloud SQL, and CDN deploy',
    'How It Helps': 'Production hosting path for NexusB2B at scale',
  },
]
